import * as React from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { ROUTE_LOGIN } from '@mc/react-app-base';

export const FallbackLoginRedirect: React.FC<RouteComponentProps> = ({
  location: { pathname, state },
}: RouteComponentProps) => {
  return (
    // @ts-ignore
    <Redirect
      to={{
        pathname: ROUTE_LOGIN,
        state: {
          from: pathname,
          fromOriginalUrl: window.location.href,
          originalState:
            state && typeof state === 'object' && Object.keys(state).length > 0
              ? JSON.stringify(state)
              : undefined,
        },
      }}
    />
  );
};
